export default __webpack_public_path__ + "static/N0231-bb88d4969534c2aadc32a0fb86404071.png";